import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';
import ENV from "packs/env.js.erb";
let mapboxgl;
let mapboxLoading;

function loadMapbox() {
  if (!mapboxLoading) {
    mapboxLoading = Promise.all([
      import('!mapbox-gl'),
      import('mapbox-gl/dist/mapbox-gl.css')
    ]).then(([module]) => {
      mapboxgl = module.default;
    }).catch(error => {
      mapboxLoading = null;
      throw error;
    });
  }
  return mapboxLoading;
}
import { countriesBounds } from "../packs/countries_bounds";

import { MDCDialog } from '@material/dialog';

import { createDetailMap } from "../maps/detail_map";
import { HomeControl } from "../maps/home_control";

import {MDCSelect} from '@material/select';

var countries_bounds = countriesBounds();

var map,
    communityValue = "",
    collectionValue = "",
    countryValue = "",
    implementationsValue = "",
    searchValue = "";

var bounds = [
    [-170,-57], // Southwest coordinates
    [190, 78] // Northeast coordinates
];

var searchTimer;

var withParam = [];

export default class extends Controller {
  static targets = ["map", "search"]

  static values = {url: String, type: String}

  initialize() {
    this.getWithParams();
    this.handleMaterialReady = () => {
      this.materialReady = true;
      if (this.typeValue === 'main' && !this.selectsReady) {
        this.initSelects();
        this.selectsReady = true;
      }
      this.loadVisibleMap();
    };
  }

  connect() {
    const connection = this.connection = Symbol();
    this.nearViewport = false;
    document.addEventListener('MDCAutoInit:End', this.handleMaterialReady);
    this.mapObserver = new IntersectionObserver(entries => {
      if (this.connection !== connection) return;
      if (entries.some(entry => entry.isIntersecting)) {
        this.nearViewport = true;
        this.loadVisibleMap();
      }
    }, { rootMargin: '200px' });
    this.mapObserver.observe(this.mapTarget);
  }

  async loadVisibleMap() {
    if (!this.materialReady || !this.nearViewport || this.mapStarting || this.mapInstance || this.detailMap || !this.element.isConnected) return;
    const connection = this.connection;
    this.mapStarting = true;
    try {
      if (this.typeValue === 'innovation') await this.initInnovationMap();
      else if (this.typeValue === 'collection') await this.initCollectionMap();
      else if (['funder', 'implementation', 'project', 'practice'].includes(this.typeValue)) await this.initTypiedMap();
      else {
        if (this.typeValue === 'community' || this.typeValue === 'youth') {
          communityValue = this.typeValue === 'community' ? 'lead' : 'youth';
          collectionValue = 'no';
        }
        await this.initMainMap();
      }
      if (this.connection === connection && (this.mapInstance || this.detailMap)) this.mapObserver.disconnect();
    } finally {
      if (this.connection === connection) this.mapStarting = false;
    }
  }

  initSelects() {
    let _this = this;

    ['collection', 'community', 'country', 'implementations'].forEach(element => {
      let selectEl = document.querySelector("#" + element + "_filter");

      if (selectEl != null) {
        let select = selectEl.MDCSelect;

        if (element == "community"){
          communityValue = select.value;
        } else if (element == "collection") {
          collectionValue = select.value;
        } else if (element == "country") {
          countryValue = select.value;
        } else if (element == "implementations") {
          implementationsValue = select.value;
        }

        select.listen('MDCSelect:change', (event) => {
          _this.applyFilter(element, select.value, select);
        });
      }
    });

    this.getGrid("users", 1);
    this.getGrid("innovations", 1);

    if (withParam.includes("funders"))
      this.getGrid("funders", 1);

    if (withParam.includes("implementations"))
      this.getGrid("implementations", 1);

    $("#map-toggle").on("click", function() {
      if ($(this).hasClass('grey') == true) {
        $(this).removeClass('grey');
        $("#map-section").removeClass("hidden");

      } else if ($("#grid-toggle").hasClass('grey') == false) {
        $(this).addClass('grey');
        $("#map-section").addClass("hidden");
      }
    });

    $("#grid-toggle").on("click", function() {
      if ($(this).hasClass('grey') == true) {
        $(this).removeClass('grey');
        $("#innovations-section").removeClass("hidden");
        $("#users-section").removeClass("hidden");
      } else if ($("#map-toggle").hasClass('grey') == false) {
        $(this).addClass('grey');
        $("#innovations-section").addClass("hidden");
        $("#users-section").addClass("hidden");
      }

    });

	}

  getMapGrid() {
    this.mapDataRequest();
    this.getGrid("users", 1);
    this.getGrid("innovations", 1);
    this.getGrid("implementations", 1);
    this.getGrid("funders", 1);
  }

  searchHandler() {
    var _this = this;

    if (_this.searchTarget.value.length > 2){
      searchValue = _this.searchTarget.value;

      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        _this.getMapGrid();
      }, 1000);
    } else {
      searchValue = "";

      if (_this.searchTarget.value.length == 0) {
        _this.getMapGrid();
      }

    }
  }

  resetSearch() {
    this.searchTarget.value = "";
    searchValue = "";
    this.getMapGrid();
  }

  getGrid(type, pg) {
    var cardAPI = "/en/map";
    let _this = this;

    if (type == "innovations") {
      $.get( cardAPI, {
        type: "innovations",
        collection: collectionValue,
        country: countryValue,
        s: searchValue,
        pg: pg,
        pagination: true
      })
      .done(function( data ) {
        if (data.length > 1) {

          if (pg <= 1) {
            $("#innovations-section .card-grid").html("");
            $("#innovations-section .card-grid.hidden").removeClass('hidden');
            $("#innovations-section .card-grid-footer.hidden").removeClass('hidden');
            $("#innovations-section .not-found:not(.hidden)").addClass('hidden');
          }

          $("#innovations-section .card-grid").append(data);
          $("#innovations-section .pagination-btn").attr("data-pg", parseInt(pg) + 1);
          $("#innovations-section .pagination-btn.hidden").removeClass("hidden");

        } else {

          if (pg <= 1) {
            $("#innovations-section .card-grid").addClass('hidden');
            $("#innovations-section .card-grid-footer").addClass('hidden');
            $("#innovations-section .not-found.hidden").removeClass('hidden');
          }

          $("#innovations-section .pagination-btn").addClass("hidden");

        }

        $("#innovations-section .pagination-btn.loading").removeClass("loading");
      });

    } else if (type == "users") {
      $.get( cardAPI, {
        type: "users",
        user_type: communityValue,
        collection: collectionValue,
        country: countryValue,
        s: searchValue,
        pg: pg,
        pagination: true,
      })
      .done(function( data ) {
        if (data.length > 1) {

          if (pg <= 1) {
            $("#users-section .card-grid").html("");
            $("#users-section .card-grid.hidden").removeClass('hidden');
            $("#users-section .card-grid-footer.hidden").removeClass('hidden');
            $("#users-section .not-found:not(.hidden)").addClass('hidden');
          }

          $("#users-section .card-grid").append(data);
          $("#users-section .pagination-btn").attr("data-pg", parseInt(pg) + 1);
          $("#users-section .pagination-btn.hidden").removeClass("hidden");

        } else {

          if (pg <= 1) {
            $("#users-section .card-grid").addClass('hidden');
            $("#users-section .card-grid-footer").addClass('hidden');
            $("#users-section .not-found.hidden").removeClass('hidden');
          }

          $("#users-section .pagination-btn").addClass("hidden");

        }

        $("#users-section .pagination-btn.loading").removeClass("loading");
      });
    } else if (type == "implementations") {
      $.get( cardAPI, {
        type: "implementations",
        user_type: "implementations",
        collection: collectionValue,
        country: countryValue,
        implementations: implementationsValue,
        s: searchValue,
        pg: pg,
        pagination: true,
      })
      .done(function( data ) {
        if (data.length > 1) {

          if (pg <= 1) {
            $("#implementations-section .card-grid").html("");
            $("#implementations-section .card-grid.hidden").removeClass('hidden');
            $("#implementations-section .card-grid-footer.hidden").removeClass('hidden');
            $("#implementations-section .not-found:not(.hidden)").addClass('hidden');
          }

          $("#implementations-section .card-grid").append(data);
          $("#implementations-section .pagination-btn").attr("data-pg", parseInt(pg) + 1);
          $("#implementations-section .pagination-btn.hidden").removeClass("hidden");

        } else {

          if (pg <= 1) {
            $("#implementations-section .card-grid").addClass('hidden');
            $("#implementations-section .card-grid-footer").addClass('hidden');
            $("#implementations-section .not-found.hidden").removeClass('hidden');
          }

          $("#implementations-section .pagination-btn").addClass("hidden");

        }

        $("#implementations-section .pagination-btn.loading").removeClass("loading");
      });
    } else if (type == "funders") {
      $.get( cardAPI, {
        type: "funders",
        user_type: communityValue,
        collection: collectionValue,
        country: countryValue,
        s: searchValue,
        pg: pg,
        pagination: true,
      })
      .done(function( data ) {
        if (data.length > 1) {

          if (pg <= 1) {
            $("#funders-section .card-grid").html("");
            $("#funders-section .card-grid.hidden").removeClass('hidden');
            $("#funders-section .card-grid-footer.hidden").removeClass('hidden');
            $("#funders-section .not-found:not(.hidden)").addClass('hidden');
          }

          $("#funders-section .card-grid").append(data);
          $("#funders-section .pagination-btn").attr("data-pg", parseInt(pg) + 1);
          $("#funders-section .pagination-btn.hidden").removeClass("hidden");

        } else {

          if (pg <= 1) {
            $("#funders-section .card-grid").addClass('hidden');
            $("#funders-section .card-grid-footer").addClass('hidden');
            $("#funders-section .not-found.hidden").removeClass('hidden');
          }

          $("#funders-section .pagination-btn").addClass("hidden");

        }

        $("#funders-section .pagination-btn.loading").removeClass("loading");
      });
    }
      
  }

  getGridPagination(event) {
    let _this = this;
    let btn = event.currentTarget;
    let pg = parseInt(event.currentTarget.dataset.pg);
    let type = event.currentTarget.dataset.type;

    if (btn.classList.contains("loading") == false) {
      btn.classList.add("loading");
      _this.getGrid(type, pg);
    }
  }

  disconnect() {
    this.connection = null;
    this.mapStarting = false;
    this.mapObserver?.disconnect();
    document.removeEventListener('MDCAutoInit:End', this.handleMaterialReady);
    this.mapInstance?.remove();
    if (map === this.mapInstance) map = null;
    this.mapInstance = null;
    this.detailMap?.remove();
    this.detailMap = null;
  }

  async initDetailMap(type) {
    const connection = this.connection;
    if (!this.element.isConnected || this.detailMap) return;
    try {
      await loadMapbox();
    } catch (error) {
      if (this.connection === connection && this.element.isConnected) window.alert("Could not load map. Please reload the page to try again.");
      return;
    }
    if (this.connection !== connection || !this.element.isConnected || this.detailMap) return;
    mapboxgl.accessToken = ENV.mapboxKey();
    const dataset = this.mapTarget.dataset;
    this.detailMap = createDetailMap(mapboxgl, this.mapTarget, type, type === 'innovation' ? {
      regions: JSON.parse(dataset.regions), countryBounds: countries_bounds
    } : {
      country: dataset.country, locations: JSON.parse(dataset.locations), countryBounds: countries_bounds,
      onSelect: (event, features) => this.initDialog(event, features, this.detailMap)
    });
  }

  initCollectionMap() {
    return this.initDetailMap('collection');
  }

  initInnovationMap() {
    return this.initDetailMap('innovation');
  }

  applyFilter(type, value, selectObject) {
    let _this = this;

    console.log(type, value,selectObject);

    if (type.length > 0) {

      if (value == 'empty')
        value = "";

      if (type == "community"){
        communityValue = value;

      } else if (type == "collection") {
        collectionValue = value;

      } else if (type == "implementations") {
        implementationsValue = value;

      } else if (type == "country") {
        countryValue = value;

        if (countryValue.length > 0)
          _this.focusCountry(countryValue);
        else if (map?.getLayer('country-boundaries')) {
          map.setFilter('country-boundaries', false);
          map.fitBounds(bounds, {
            padding: 20
          });
        }
      }

      this.getMapGrid();
    }
  }

  mapDataRequest() {
    const source = map?.getSource('objects');
    if (!source) return;

    fetch("/en/new-map?type=" + communityValue + "&country=" + countryValue + "&collection=" + collectionValue + "&s=" + searchValue+ "&implementations=" + implementationsValue)
    .then(response => response.json())
    .then(data => {
      if (this.mapInstance?.getSource('objects') === source) source.setData(data);
    });
  }

  resetMap(event) {
    var select1 = document.querySelector("#collection_filter").MDCSelect;
    select1.selectedIndex = 0;

    var select2 = document.querySelector("#community_filter").MDCSelect;
    select2.selectedIndex = 0;

    var select3 = document.querySelector("#country_filter").MDCSelect;
    select3.selectedIndex = 0;

    var select4 = document.querySelector("#implementations_filter").MDCSelect;
    select4.selectedIndex = 1;

    if (map?.getLayer('country-boundaries')) {
      map.setFilter('country-boundaries', false);
      map.fitBounds(bounds, {
        padding: 20
      });
    }

    communityValue = "";
    collectionValue = "";
    countryValue = "";
    implementationsValue = "";
    this.resetSearch();
  }

  async initMainMap(event) {
    const connection = this.connection;
    try {
      await loadMapbox();
    } catch (error) {
      if (this.connection === connection && this.element.isConnected) window.alert("Could not load map. Please reload the page to try again.");
      return;
    }
    if (this.connection !== connection || !this.element.isConnected) return;
    let _this = this;
    let mapstyle = 'mapbox://styles/hundred-org/ckmopzq5j4ax817ly3iea0sfu?refresh=true';

    if (this.mapTarget.dataset.mapstyle !== undefined) {
      console.log(this.mapTarget.dataset.mapstyle);
      mapstyle = 'mapbox://styles/mapbox/' + this.mapTarget.dataset.mapstyle;
    }

    mapboxgl.accessToken = ENV.mapboxKey();
    map = this.mapInstance = new mapboxgl.Map({
      container: 'map',
      style: mapstyle,
      //center: [10.400000, 43.716667],
      zoom: -1,
      maxZoom: 9,
      maxBounds: bounds,
      attributionControl: false
    });

    map.addControl(new mapboxgl.AttributionControl({
      compact: true
    }));

    map.scrollZoom.disable();
    map.addControl(new mapboxgl.NavigationControl());
    const initialCountry = countryValue;
    map.addControl(new HomeControl(currentMap => {
      const coordinates = countries_bounds[initialCountry];
      currentMap.fitBounds(coordinates ? [[coordinates.sw.lon, coordinates.sw.lat], [coordinates.ne.lon, coordinates.ne.lat]] : bounds, { padding: 20, bearing: 0, pitch: 0, linear: true, duration: 300 });
    }));
    
    const activeMap = map;
    map.on('load', function() {
      if (_this.mapInstance !== activeMap) return;
      const map = activeMap;
      $(".overlay").fadeOut( "slow");

      map.addSource('objects', {
        type: 'geojson',
        data: "/en/new-map?type=" + communityValue + "&country=" + countryValue + "&collection=" + collectionValue + "&s=" + searchValue + "&implementations=" + implementationsValue + "&with[]=" + withParam.join("&with[]="),
        cluster: true,
        clusterMaxZoom: 10, // Max zoom to cluster points on
        clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
        clusterProperties: {
        // keep separate counts for each category in a cluster
          has_innovation: ["any", ["==", ["get", "entity"], 'Innovation'], "false"],
          has_user: ["any", ["==", ["get", "entity"], 'User'], "false"],
          has_implementation: ["any", ["==", ["get", "entity"], 'Implementation'], "false"],
          has_funder: ["any", ["==", ["get", "entity"], 'Funder'], "false"],
          only_innovation: ["all", ["==", ["get", "entity"], 'Innovation'], "false"],
          only_user: ["all", ["==", ["get", "entity"], 'User'], "false"],
          only_implementation: ["all", ["==", ["get", "entity"], 'Implementation'], "false"],
          only_funder: ["all", ["==", ["get", "entity"], 'Funder'], "false"]
        }
      });

      map.addLayer(
        {
          id: 'country-boundaries',
          source: {
            type: 'vector',
            url: 'mapbox://mapbox.country-boundaries-v1',
          },
          'source-layer': 'country_boundaries',
          type: 'fill',
          paint: {
            'fill-color': '#000',
            'fill-opacity': 0.1,
          },
        }
      );

      map.setFilter('country-boundaries', false);
      if (countryValue.length > 0) _this.focusCountry(countryValue);

      Promise.all(
          [
            {url: '/cluster-black.png', id: "black"}, 
            {url: '/cluster-plum.png', id: "plum"},
            {url: '/cluster-blue.png', id: "blue"},
            {url: '/cluster-black-plum.png', id: "plum_black"}
          ].map(img => new Promise((resolve, reject) => {
              map.loadImage(img.url, function (error, res) {
                  if (_this.mapInstance !== map) { resolve(); return; }
                  map.addImage(img.id, res)
                  resolve();
              })
          }))
      )
      .then(data => {
        if (_this.mapInstance !== map) return;
        map.addLayer({
          id: 'clusters',
          type: 'symbol',
          source: 'objects',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 16,

            'icon-image': [
              "case",
              ["all", ["get", "has_innovation"], ["get", "has_user"]], 
              "plum_black",
              ["all", ["get", "has_innovation"], ["get", "has_funder"]], 
              "plum_black",
              ["all", ["get", "has_innovation"], ["get", "has_funder"], ["get", "has_user"]], 
              "plum_black",
              ["all", ["get", "has_funder"], ["get", "has_user"]], 
              "black",
              ["get", "only_user"],
              "black",
              ["get", "only_funder"],
              "black",
              ["get", "only_implementation"],
              "blue",
              "plum"
            ], // reference the image
            'icon-size': 0.6,
          },           
          paint: {
            "text-color": "#fff"
          }
        });

      });
       
      map.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'objects',
        filter: ['!', ['has', 'point_count']],
        paint: {
          //'circle-color': ["rgb",  ["get", "entity"], '#c32fa0'],
          'circle-color': [
            'match',
            ['get', 'entity'],
            'User',
            '#000000',
            'Implementation',
            '#117C96',
            'Funder',
            '#000000',
            /* other */ '#c32fa0'
          ],
          'circle-radius': 10,
          'circle-stroke-width': 0.5,
          'circle-stroke-color': '#fff'
        }
      });

      map.addLayer({
        id: 'unclustered-count',
        type: 'symbol',
        source: 'objects',
        filter: ['!', ['has', 'point_count']],
        layout: {
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        },
        paint: {
          "text-color": "#fff"
        }
      });

      map.on('click', 'clusters', function (e) {
        var features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        });
        
        var features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
        var clusterId = features[0].properties.cluster_id,
        point_count = features[0].properties.point_count,
        clusterSource = map.getSource('objects');

        if (map.getZoom() > 6.5) {
          clusterSource.getClusterLeaves(clusterId, point_count, 0, function(err, aFeatures){
            _this.initDialog(e,  aFeatures, map);
          });
        } else {


          map.getSource('objects').getClusterExpansionZoom(
            clusterId,
            function (err, zoom) {
              if (err) return;
               
              map.easeTo({
                center: features[0].geometry.coordinates,
                zoom: zoom
              });
            }
          );
        }

      });

      map.on('click', 'unclustered-point', function (e) {
        _this.initDialog(e,  e.features, map);
      });

      map.on('mouseenter', 'clusters', function () {
        map.getCanvas().style.cursor = 'pointer';
      });

      map.on('mouseleave', 'clusters', function () {
        map.getCanvas().style.cursor = '';
      });

      map.on('mouseenter', 'unclustered-point', function () {
        map.getCanvas().style.cursor = 'pointer';
      });

      map.on('mouseleave', 'unclustered-point', function () {
        map.getCanvas().style.cursor = '';
      });

    });
  }

  async initTypiedMap() {
    const connection = this.connection;
    try {
      await loadMapbox();
    } catch (error) {
      if (this.connection === connection && this.element.isConnected) window.alert("Could not load map. Please reload the page to try again.");
      return;
    }
    if (this.connection !== connection || !this.element.isConnected) return;
    let _this = this;

    mapboxgl.accessToken = ENV.mapboxKey();
    map = this.mapInstance = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/hundred-org/ckmopzq5j4ax817ly3iea0sfu?refresh=true',
      zoom: -1,
      maxZoom: 10,
      maxBounds: bounds,
      attributionControl: false
    });

    map.addControl(new mapboxgl.AttributionControl({
      compact: true
    }));

    map.scrollZoom.disable();
    map.addControl(new mapboxgl.NavigationControl());
    let initialBounds = bounds;
    let initialPadding = 20;
    map.addControl(new HomeControl(currentMap => currentMap.fitBounds(initialBounds, { padding: initialPadding, bearing: 0, pitch: 0, linear: true, duration: 300 })));
    
    const activeMap = map;
    map.on('load', function() {
      if (_this.mapInstance !== activeMap) return;
      const map = activeMap;
      $(".overlay").fadeOut( "slow");
      map.addSource('objects', {
        type: 'geojson',
        data: {"type": "FeatureCollection","features": []}
      });

      fetch('/en/addresses?'+ _this.typeValue +'_id=' + _this.mapTarget.dataset.objectid)
      .then(response => response.json())
      .then((data) => {
        if (_this.mapInstance !== map) return;
        map.getSource('objects').setData(data);

        var bounds = new mapboxgl.LngLatBounds();

        data.features.forEach(function(feature) {
            bounds.extend(feature.geometry.coordinates);
        });

        initialBounds = bounds;
        initialPadding = 100;
        map.fitBounds(bounds, { padding: 100 });
      });

      map.addLayer(
        {
          id: 'country-boundaries',
          source: {
            type: 'vector',
            url: 'mapbox://mapbox.country-boundaries-v1',
          },
          'source-layer': 'country_boundaries',
          type: 'fill',
          paint: {
            'fill-color': '#000',
            'fill-opacity': 0.1,
          },
        }
      );

      map.setFilter('country-boundaries', false);

      Promise.all(
          [
            {url: '/cluster-black.png', id: "black"}, 
            {url: '/cluster-plum.png', id: "plum"},
            {url: '/cluster-black-plum.png', id: "plum_black"}
          ].map(img => new Promise((resolve, reject) => {
              map.loadImage(img.url, function (error, res) {
                  if (_this.mapInstance !== map) { resolve(); return; }
                  map.addImage(img.id, res)
                  resolve();
              })
          }))
      )
      .then(data => {
        if (_this.mapInstance !== map) return;
        map.addLayer({
          id: 'clusters',
          type: 'symbol',
          source: 'objects',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 16,

            'icon-image': [
              "case",
              ["all", ["get", "has_innovation"], ["get", "has_user"]], 
              "plum_black",
              ["all", ["get", "has_funder"], ["get", "has_user"]], 
              "black",
              ["get", "only_user"],
              "black",
              ["get", "only_funder"],
              "black",
              ["get", "only_implementation"],
              "blue",
              "plum"
            ], // reference the image
            'icon-size': 0.6,
          },           
          paint: {
            "text-color": "#fff"
          }
        });

      });
       
      map.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'objects',
        filter: ['!', ['has', 'point_count']],
        paint: {
          //'circle-color': ["rgb",  ["get", "entity"], '#c32fa0'],
          'circle-color': [
            'match',
            ['get', 'entity'],
            'User',
            '#000000',
            'Implementation',
            '#117C96',
            'Funder',
            '#000000',
            /* other */ '#c32fa0'
          ],
          'circle-radius': 10,
          'circle-stroke-width': 0.5,
          'circle-stroke-color': '#fff'
        }
      });

      map.addLayer({
        id: 'unclustered-count',
        type: 'symbol',
        source: 'objects',
        filter: ['!', ['has', 'point_count']],
        layout: {
          //'text-field': ['get', 'amount'],

          //'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        },
        paint: {
          "text-color": "#fff"
        }
      });
    });

  }

  initDialog(event, features, map) {
    let dialog = null;

    let dialogTemplate = document.querySelector("#map-dialog-template");
    let dialogEl = null;

    const div = document.createElement('div');
    div.innerHTML = dialogTemplate.innerHTML;
    dialogEl = div.firstElementChild;
    dialogEl.classList.add("current-map-dialog");
    document.body.appendChild(dialogEl);


    let elements = [...new Set(features.map(x => x.properties.id))];
    var ids = "";

    elements.forEach(function(element) {
      ids += "ids[]=" + element + "&"
    })


    dialog = new MDCDialog(dialogEl);

    dialog.open();

    $.getScript("/en/new-map.js?" + ids);

    dialog.listen('MDCDialog:closed', function() {
      dialog.root.remove();
    });
   
  }

  focusCountry(countryAlpha3) {

    if (map?.getLayer('country-boundaries')) {
      if (countryAlpha3.length > 0){
      
        map.setFilter('country-boundaries', [
          "in",
          "iso_3166_1_alpha_3",
          countryAlpha3
        ]);
      
        var coords = countries_bounds[countryAlpha3];
        map.fitBounds([[coords.sw.lon, coords.sw.lat],[coords.ne.lon, coords.ne.lat]], {
          padding: 20
        });
      } else {
        map.setFilter('country-boundaries', false);
      }
    }
  }

  getWithParams() {
    //PARAMS 
    let params = new URLSearchParams(document.location.search);
    withParam = params.getAll("with[]"); //
  }

}
